var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import Icon from './common/Icon';
import Color from './common/Color';
import Image from './common/BackGroundImage';
var Panel = Collapse.Panel;
var EditorBg = /** @class */ (function (_super) {
    __extends(EditorBg, _super);
    function EditorBg() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (key, v, isDrag) {
            var _a;
            var value = __assign(__assign({}, _this.props.value), (_a = {}, _a[key] = v, _a));
            _this.props.onChange('background', value, isDrag);
        };
        return _this;
    }
    EditorBg.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, locale = _a.locale, onChange = _a.onChange, editorElem = _a.editorElem, props = __rest(_a, ["value", "locale", "onChange", "editorElem"]);
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            React.createElement(Color, { onChange: function (e, isDrag) {
                    _this.onChange('color', e, isDrag);
                }, title: React.createElement(Icon, { type: "bg-colors", prompt: locale.color }), color: value.color }),
            React.createElement(Image, { onChange: function (e, isDrag) {
                    _this.onChange('image', e, isDrag);
                }, locale: locale, value: value.image, editorElem: editorElem })));
    };
    EditorBg.propTypes = {
        className: PropTypes.string,
        header: PropTypes.string,
        onChange: PropTypes.func,
        value: PropTypes.object,
        locale: PropTypes.object,
        editorElem: PropTypes.any,
    };
    EditorBg.defaultProps = {
        className: 'editor-bg',
        value: {
            color: null,
            image: {
                url: [''],
                repeat: ['repeat'],
                position: ['center'],
                size: ['contain'],
                attachment: ['scroll'],
            }
        },
        onChange: function () { },
    };
    return EditorBg;
}(Component));
EditorBg.componentName = 'EditorBackGround';
export default EditorBg;
